module.exports = __webpack_public_path__ + "static/img/rongyu7.f999eb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rongyu7.jpg
// module id = OcGz
// module chunks = 1